<div class="input" [style.border-radius]="border_radios ? '14px' : ''"
     [style.border-color]="control.value ? '#008A2F' : error ? '#ff0000' :'#000'"
     [style.background]="backGround" [style.border]="border ? '' : 'none'" >
  <div class="input-wrapper" >
    <input id="data" #inputData autocomplete="off" [style.background]="backGround" [mask]="mask"
           (change)="validarValor()"
           [type]="type" [formControl]="formControl" [placeholder]="isFocused ? placeholder : ''" >
    <label [style.border-radius]="border_radios ? '14px' : ''" [class.active]="isFocused || control.value"
           [style.color]="error ? '#ff0000' : ''"
           [style.background]="backGround" >{{ placeholder }}</label >
  </div >
  <span class="material-symbols-outlined color-icon" (click)="limparControl(inputData)"
        [style.color]="control.value ? '#008A2F' : error ? '#ff0000' :'#000'" [style.cursor]="'pointer'"
        [style.cursor]="control.value ? 'pointer' : ''" >
    @if (icon === 'search' && control.value) {
      close
    } @else {
      {{ icon }}
    }
  </span >
</div >
@if (error) {
  <div class="error" >
    <h6 >Campo Obrigatorio</h6 >
    <span class="material-symbols-outlined" >
      info
      </span >
  </div >
}
